var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyAlbum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.495 48C26.4325 48.4426 26.4002 48.8949 26.4002 49.3547C26.4002 54.6566 30.6983 58.9547 36.0002 58.9547C41.3021 58.9547 45.6002 54.6566 45.6002 49.3547C45.6002 48.8949 45.5679 48.4426 45.5054 48H68.8002V69.3547C68.8002 70.6802 67.7257 71.7547 66.4002 71.7547H5.6002C4.27471 71.7547 3.2002 70.6802 3.2002 69.3547V48H26.495Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4002 48.8C46.4002 54.5438 41.744 59.2 36.0002 59.2C30.2564 59.2 25.6002 54.5438 25.6002 48.8C25.6002 48.6139 25.6051 48.429 25.6147 48.2453H3.2002L10.8485 25.6311C11.1783 24.6562 12.0929 24 13.122 24H58.8784C59.9075 24 60.8221 24.6562 61.1518 25.6311L68.8002 48.2453H46.3857C46.3953 48.429 46.4002 48.6139 46.4002 48.8Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8784 49.5638C44.8784 54.0022 40.9036 58.4002 36.0004 58.4002C31.0972 58.4002 27.1223 54.0022 27.1223 49.5638C27.1223 49.42 27.1265 48.4771 27.1348 48.3352H10.4004L16.9295 32.4606C17.2109 31.7072 17.9917 31.2002 18.8703 31.2002H53.1305C54.0091 31.2002 54.7898 31.7072 55.0713 32.4606L61.6004 48.3352H44.866C44.8743 48.4771 44.8784 49.42 44.8784 49.5638Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8784 49.5638C44.8784 54.0022 40.9036 58.4002 36.0004 58.4002C31.0972 58.4002 27.1223 54.0022 27.1223 49.5638C27.1223 49.42 27.1265 48.4771 27.1348 48.3352H10.4004L16.9295 32.4606C17.2109 31.7072 17.9917 31.2002 18.8703 31.2002H53.1305C54.0091 31.2002 54.7898 31.7072 55.0713 32.4606L61.6004 48.3352H44.866C44.8743 48.4771 44.8784 49.42 44.8784 49.5638Z",
    fill: "#36C19E",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2002 48.4098V69.6C4.2002 70.3732 4.827 71 5.6002 71H66.4002C67.1734 71 67.8002 70.3732 67.8002 69.6V48.4098L60.2045 25.9515C60.0122 25.3828 59.4787 25 58.8784 25H13.122C12.5217 25 11.9882 25.3828 11.7958 25.9515L4.2002 48.4098Z",
    stroke: "#36C19E",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 48C17.5493 48 20.9479 48 24.5959 48C26.097 48 26.097 49.0549 26.097 49.6C26.097 54.9019 30.4939 59.2 35.9178 59.2C41.3417 59.2 45.7387 54.9019 45.7387 49.6C45.7387 49.0549 45.7387 48 47.2397 48H67.2M8.45898 48H10.4H8.45898Z",
    stroke: "#36C19E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0801 5.84258L47.2004 15.8051M35.2801 2.40039V15.8051V2.40039ZM14.4004 5.84258L23.2801 15.8051L14.4004 5.84258Z",
    stroke: "#36C19E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAlbum);
export default __webpack_public_path__ + "static/media/empty_album.f9faa1b4f71330d8837539134a73d8ee.svg";
export { ForwardRef as ReactComponent };